// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-deck-admin-banner {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  z-index: 1001;
  padding: 10px 18px;
  min-width: 0;
}
.nkl-deck-admin-banner .admin-user-info span {
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 24px;
}
.nkl-deck-admin-banner .admin-user-info .ant-space-item-split .ant-divider.ant-divider-vertical {
  border-left-color: rgba(255, 255, 255, 0.54);
  height: 20px;
}
.nkl-deck-admin-banner #admin-logout-btn:focus {
  box-shadow: unset;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs {
  background-color: #de1b1b;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn {
  color: #ffffff;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn:hover {
  background-color: #f55353;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn:hover,
.nkl-deck-admin-banner.nkl-deck-admin-banner-loggedInAs #admin-logout-btn:focus {
  color: #ffffff;
  border-color: #f55353;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs {
  background-color: #FFFF00;
  color: #000000;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs .ant-space-item span {
  color: #000000;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs .admin-user-info,
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs .admin-user-info .ant-space-item {
  min-width: 0;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn {
  color: #000000;
  border: none;
  gap: 7px;
}
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn:hover,
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn:focus,
.nkl-deck-admin-banner.nkl-deck-admin-banner-actingAs #delegate-end-session-btn:focus-visible {
  background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/deck/admin-banner/admin-banner.less"],"names":[],"mappings":"AAGA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAFJ;AANA;EAYY,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;AAZA;EAoBgB,4CAAA;EACA,YAAA;AALhB;AAhBA;EA2BQ,iBAAA;AARR;AAWI;EACI,yBAAA;AATR;AAQI;EAIQ,cAAA;AATZ;AAWY;EACI,yBAAA;AAThB;AAYY;;EAEI,cAAA;EACA,qBAAA;AAVhB;AAeI;EACI,yBAAA;EACA,cAAA;AAbR;AAWI;EAKQ,cAAA;AAbZ;AAQI;;EAUQ,YAAA;AAdZ;AAII;EAcQ,cAAA;EACA,YAAA;EACA,QAAA;AAfZ;AAiBY;;;EAGI,yBAAA;AAfhB","sourcesContent":["@import '@nackle/origami/dist/less/color-vars.less';\n@import '@nackle/origami/dist/less/typography-vars.less';\n\n.nkl-deck-admin-banner {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    height: 50px;\n    z-index: 1001;\n    padding: 10px 18px;\n    min-width: 0;\n\n    .admin-user-info {\n        span {\n            color: @white;\n            font-size: @font-size-12;\n            font-weight: @font-weight-semibold;\n            line-height: @line-height-16;\n        }\n\n        .ant-space-item-split {\n            .ant-divider.ant-divider-vertical {\n                border-left-color: rgba(255, 255, 255, 0.54);\n                height: 20px;\n            }\n        }\n    }\n\n    #admin-logout-btn:focus {\n        box-shadow: unset;\n    }\n\n    &.nkl-deck-admin-banner-loggedInAs {\n        background-color: @red;\n\n        #admin-logout-btn {\n            color: @white;\n\n            &:hover {\n                background-color: @red-hover;\n            }\n\n            &:hover,\n            &:focus {\n                color: @white;\n                border-color: @red-hover;\n            }\n        }\n    }\n\n    &.nkl-deck-admin-banner-actingAs {\n        background-color: #FFFF00;\n        color: @black;\n\n        .ant-space-item span {\n            color: @black;\n        }\n\n        .admin-user-info,\n        .admin-user-info .ant-space-item {\n            min-width: 0;\n        }\n\n        #delegate-end-session-btn {\n            color: @black;\n            border: none;\n            gap: 7px;\n\n            &:hover,\n            &:focus,\n            &:focus-visible {\n                background-color: @white;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
